import { useState, useEffect } from 'react';

const useTime = (timeZone) => {
  const [time, setTime] = useState('');

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const options = {
        timeZone: timeZone,
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true, // Set to true for AM/PM format
      };
      // Use en-US locale to get the standard AM/PM
      setTime(new Intl.DateTimeFormat('en-US', options).format(now));
    };

    updateClock();
    const intervalId = setInterval(updateClock, 1000);

    return () => clearInterval(intervalId);
  }, [timeZone]);

  return time;
};

export default useTime;